var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.731,
    height: 29.893,
    viewBox: "0 0 27.731 29.893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    d: "M4.091-1A5.091,5.091,0,1,1-1,4.091,5.1,5.1,0,0,1,4.091-1Zm0,8.182A3.091,3.091,0,1,0,1,4.091,3.095,3.095,0,0,0,4.091,7.182Z",
    transform: "translate(17.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    d: "M4.091-1A5.091,5.091,0,1,1-1,4.091,5.1,5.1,0,0,1,4.091-1Zm0,8.182A3.091,3.091,0,1,0,1,4.091,3.095,3.095,0,0,0,4.091,7.182Z",
    transform: "translate(0 9.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    d: "M4.091-1A5.091,5.091,0,1,1-1,4.091,5.1,5.1,0,0,1,4.091-1Zm0,8.182A3.091,3.091,0,1,0,1,4.091,3.095,3.095,0,0,0,4.091,7.182Z",
    transform: "translate(17.549 19.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    "data-name": "Line 4",
    d: "M.5,6.829l-1-1.734L9.874-.867l1,1.734Z",
    transform: "translate(7.695 6.086)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_5",
    "data-name": "Line 5",
    d: "M9.879,6.758-.494.87.494-.87,10.866,5.018Z",
    transform: "translate(7.695 15.92)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.384e7dd2606e8e1727d062354cacf089.svg";
export { ForwardRef as ReactComponent };